import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faPartyHorn } from '@fortawesome/pro-duotone-svg-icons';

import { IEditorForm } from '../../models/survey-editor/editor-form.interface';
import { TextEditorSettings } from '../../models/text-editor-settings.model';

@Component({
  selector: 'empathy-end-page-form',
  templateUrl: 'end-page-form.component.html',
  styleUrls: ['./end-page-form.component.scss', './_end-page-form-theme.component.scss']
})
export class EndPageFormComponent {
  @Input() editorForm: FormGroup<IEditorForm>;

  faPartyHorn = faPartyHorn;

  textareaSettings = new TextEditorSettings('textarea', false);
}
